<template>
  <Container type="card-full">
    <el-form :model="role" label-position="left" >
      <el-row>
        <el-col :span="7">
          <el-form-item label="角色名称" label-width="100px">
            <el-input v-model="role.rolename" :maxlength="20" :disabled="true"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="">
            <el-button type='primary' @click="authFormAll">授权所有功能</el-button>
            <el-button type='primary' @click="cancelFormAll">取消所有功能</el-button>
            <!-- <el-button @click="close">关闭</el-button> -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="container">
      <vgtree class="xTree" ref="xTree" :list="list" tableheight="600" flexname="" :cols="cols" :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick" @getxTree="getxTree">
      </vgtree>
      <el-form ref="form"   class="content ss-fl" v-if="btnForm">
        <el-form-item label="" label-width="100px">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAll">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="btnIds" @change="handleChecked">
            <el-checkbox v-for="item in btnList" :label="item.btnid" :key="item.btnid">{{item.btnname}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="" label-width="100px">
          <el-button type='primary' @click="save" :loading="btnLoading">保存</el-button>
        </el-form-item>
      </el-form>

    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  export default {
    name: "roleAuthForm",
    data () {
      return {
        role: this.$route.params.form,
        type: Number(this.$route.params.type),
        btnLoading: false,
        isIndeterminate: true,
        checkAll: false,
        menuid: 0,
        btnForm: false,
        btnList: [],
        btnIds: [],
        menuList: [],
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'menuname', fieldtype: 'C', title: '菜单名称',calculExpr:'',addNewRowFlg: false}
        ],
      }
    },
    activated () {
      this.role = this.$route.params.form
      this.type = Number(this.$route.params.type)
      this.isIndeterminate = false
      this.checkAll = false
      this.menuid = 0
      this.btnForm = false
      this.getPageList()
    },
    watch: {
    },
    filters: {
    },
    components: {vgtree},
    methods: {
      async authFormAll() {
        let model = {
          roleid: this.role.roleid,
          comid: this.$store.getters.loginUser.usercomid
        }
        let data = await request({
          url: '/xtgl/role/authAllRoleMenu',
          method: 'post',
          data: model
        })
        if (data.issuccess === 1) {
          this.$message.success('角色授权功能成功！')
        } else {
          this.$message.error('角色授权功能失败！')
        }
      },
      async cancelFormAll() {
        let model = {
          roleid: this.role.roleid
        }
        let data = await request({
          url: '/xtgl/role/cancelAllRoleMenu',
          method: 'post',
          data: model
        })
        if (data.issuccess === 1) {
          this.$message.success('取消角色所有授权功能成功！')
        } else {
          this.$message.error('取消角色所有授权功能失败！')
        }
      },
      handleCheckAll(val) {
        if (val) {
          this.btnList.forEach(v => {
            this.btnIds.push(v.btnid)
          })
        } else {
          this.btnIds = []
        }
        this.isIndeterminate = false
      },
      handleChecked(value) {
        let checkedCount = value.length
        this.checkAll = checkedCount === this.btnList.length
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.btnList.length
      },
      async cellClick (row) {
        let form = row.row
        if (form.menutype === 2) {
          this.menuid = form.menuid
          this.btnIds = []
          this.btnList = await request({
            method: 'get',
            url: '/kfgl/menu/getBtnByMenu',
            params: {menuid: this.menuid}
          })
          let data = await request({
            method: 'get',
            url: '/xtgl/role/getRoleMenubtnByRoleAndMenu',
            params: {menuid: this.menuid, roleid: this.role.roleid}
          })
          data.forEach(v => {
            this.btnIds.push(v.btnid)
          })
          this.checkAll = this.btnIds.length === this.btnList.length
          this.btnForm = true
        } else {
          this.btnForm = false
        }
      },
      async save () {
        let model = {
          roleid: this.role.roleid,
          menuid: this.menuid,
          btnIds: this.btnIds
        }
        let data = await request({
          url: '/xtgl/role/saveRoleMenuByRole',
          method: 'post',
          data: model
        })
        if (data.issuccess === 1) {
          this.$message.success('角色授权功能成功！')
        } else {
          this.$message.error('角色授权功能失败！')
        }
      },
      async getxTree(xtree) {
        this.xTree = xtree
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/menu/getMenuTree',
          params: {}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'roleIndex'})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .xTree {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
